import React, { Component, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import UtilService from "../services/Celcoin/utilService";
import PrivateRoute from "./protectedRoutes";

import Login from "../pages/Login";
import Home from "../pages/Home";
import Init from "../pages/Init";
import Register from "../pages/Register";
import RegisterPF from "../pages/RegisterPF";
import SecuritySetup from "../pages/SecuritySetup";

import Pix from "../pages/Transfers/Pix";
import Ted from "../pages/Transfers/Ted";
import TedBank from "../pages/Transfers/TedBank";
import BarcodeBilling from "../pages/Transfers/BarcodeBilling";

import Receipts from "../pages/Receipts";
import CryptoCurrency from "../pages/CryptoCurrency";
import Exchange from "../pages/Exchange";

import Statements from "../pages/Account/Statement";
import Med from "../pages/Account/Med";

import SettingsAndSecurity from "../pages/SettingsAndSecurity";
import Contabil from "../pages/SettingsAndSecurity/Statement";
import SubUsers from "../pages/SettingsAndSecurity/SubUsers";
import RegisterVerification from "../pages/RegisterVerification";

import Ramps from "../pages/Ramps";
import Swap from "../pages/Swap";
import { hasRampsEnabled, hasSwapEnabled } from "../utils/servicesEnable";

class AppRoutes extends Component {
  componentDidMount() {
    this.interval = setInterval(() => {
      UtilService.checkSessionExpiration();
    }, 60 * 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <BrowserRouter>
        <Suspense fallback={""}>
          <Routes>
            <Route exact path="/" element={<Init />} />

            <Route exact path="/login" element={<Login />} />

            <Route exact path="/security-setup" element={<SecuritySetup />} />

            <Route
              path="/register-verification"
              element={<RegisterVerification />}
            />

            <Route exact path="/register" element={<Register />} />

            <Route exact path="/registerPF" element={<RegisterPF />} />

            <Route exact path="/user" element={<PrivateRoute />}>
              <Route exact path="/user" element={<Home />} />
            </Route>

            <Route exact path="/transfers/pix" element={<PrivateRoute />}>
              <Route exact path="/transfers/pix" element={<Pix />} />
            </Route>
            <Route exact path="/transfers/ted" element={<PrivateRoute />}>
              <Route exact path="/transfers/ted" element={<Ted />} />
            </Route>

            {/*
              TED bancário pela ordem de payout (mesmo endpoint do PIX, com os dados da conta
              do recebedor). Rota SEPARADA da /transfers/ted, que é o fluxo antigo: apontar a
              tela existente para cá mudaria o caminho de quem já opera por ela, e os dois
              precisam conviver enquanto houver cliente em cada um.
            */}
            <Route exact path="/transfers/tedBank" element={<PrivateRoute />}>
              <Route exact path="/transfers/tedBank" element={<TedBank />} />
            </Route>
            <Route
              exact
              path="/transfers/barcodeBilling"
              element={<PrivateRoute />}
            >
              <Route
                exact
                path="/transfers/barcodeBilling"
                element={<BarcodeBilling />}
              />
            </Route>

            <Route exact path="/exchange" element={<PrivateRoute />}>
              <Route exact path="/exchange" element={<Exchange />} />
            </Route>

            <Route exact path="/cryptoCurrency" element={<PrivateRoute />}>
              <Route
                exact
                path="/cryptoCurrency"
                element={<CryptoCurrency />}
              />
            </Route>

            <Route exact path="/receipts" element={<PrivateRoute />}>
              <Route exact path="/receipts" element={<Receipts />} />
            </Route>

            {/*
              Não há rota de chaves PIX aqui: a gestão de chaves vive na aba "Chaves" da tela
              de PIX, que é onde quem opera PIX já está. Uma segunda tela para a mesma coisa
              criaria duas listas da mesma conta, e a que ninguém revisasse seria a que
              envelheceria.
            */}

            <Route exact path="/accounts/med" element={<PrivateRoute />}>
              <Route exact path="/accounts/med" element={<Med />} />
            </Route>

            <Route exact path="/accounts/statements" element={<PrivateRoute />}>
              <Route
                exact
                path="/accounts/statements"
                element={<Statements />}
              />
            </Route>

            <Route exact path="/accounts/payin" element={<PrivateRoute />}>
              <Route
                exact
                path="/accounts/payin"
                element={<Statements statementMode="payin" />}
              />
            </Route>

            <Route exact path="/accounts/payout" element={<PrivateRoute />}>
              <Route
                exact
                path="/accounts/payout"
                element={<Statements statementMode="payout" />}
              />
            </Route>

            <Route exact path="/settingsAndSecurity" element={<PrivateRoute />}>
              <Route
                exact
                path="/settingsAndSecurity"
                element={<SettingsAndSecurity />}
              />
            </Route>

            <Route exact path="/managerUsers" element={<PrivateRoute />}>
              <Route exact path="/managerUsers" element={<SubUsers />} />
            </Route>
            <Route exact path="/ramps" element={<PrivateRoute />}>
              <Route
                exact
                path="/ramps"
                element={hasRampsEnabled() ? <Ramps /> : <Home />}
              />
            </Route>
            <Route exact path="/swap" element={<PrivateRoute />}>
              <Route
                exact
                path="/swap"
                element={hasSwapEnabled() ? <Swap /> : <Home />}
              />
            </Route>
            <Route exact path="/contabil" element={<PrivateRoute />}>
              <Route exact path="/contabil" element={<Contabil />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    );
  }
}

export default AppRoutes;
